import React from 'react';

import { CustomerDetailsAccordion } from '@/views/customerDetails/components/CustomerDetailsAccordion.comp.tsx';
import { ProcessesListTable } from '@/views/processes/list/components/table/ProcessesListTable.comp.tsx';

type Props = {
  contactId: number;
};

export const ContactDetailsProcesses: React.FC<Props> = ({ contactId }) => {
  return (
    <CustomerDetailsAccordion expanded>
      <ProcessesListTable
        contactId={contactId}
        tableKey={`contact_details_processes-${contactId}`}
      />
    </CustomerDetailsAccordion>
  );
};
